import { z } from 'zod';

/**
 * Le cercle de visibilite d'une chose (spec partage-cercles-et-repas).
 *
 * Partage entre l'API et l'application pour que le message affiche a la saisie ne
 * puisse pas diverger de la regle appliquee cote serveur — comme tous les schemas de
 * ce paquet.
 */
export const cercleSchema = z
  .object({
    visibility: z.enum(['HOUSEHOLD', 'PRIVATE', 'CHOSEN'], {
      message: 'Cercle invalide',
    }),
    sharedWithUserIds: z.array(z.string()).default([]),
  })
  .refine((v) => v.visibility !== 'CHOSEN' || v.sharedWithUserIds.length > 0, {
    message: 'Choisis au moins une personne',
  })
  // Un cercle FOYER ou PRIVE ne liste personne : une liste residuelle serait une
  // donnee morte qui ressurgirait au prochain changement de cercle.
  .transform((v) => ({
    visibility: v.visibility,
    sharedWithUserIds: v.visibility === 'CHOSEN' ? v.sharedWithUserIds : [],
  }));

export type CercleInput = z.infer<typeof cercleSchema>;
